import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser, CommaFire } from "../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../context";
import { PurchaseHistoryApi , PurchaseHistoryExportApi } from "../../api";
import { DatePicker } from "jalali-react-datepicker";
import { convertDateToString, converDurationToMin } from "../../utils";
import { Link } from 'react-router-dom'

export const PurchaseHistory = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [tableData, setTableData] = useState<any>([])
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [jsonParms, setJsonParms] = useState({ 'page': 1 })

    const changePage = (type: string) => {
        let data = { ...jsonParms };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        setJsonParms(data)
        getData(data)
    }

    const exportFile = async (id: any) => {
        // CtxLoad.setDisplayLoadingBlur(true)
        const res: any = await PurchaseHistoryExportApi(id)
        // CtxLoad.setDisplayLoadingBlur(false)
        var el = document.createElement("a");
        el.setAttribute("href", res);
        el.setAttribute("download", 'pdf');
        el.setAttribute("target", '_blank');
        document.body.appendChild(el);
        el.click();
        el.remove();
    }

    const getData = async (params: any) => {
        try {
            CtxLoad.setDisplayLoadingBlur(true)
            let res = await PurchaseHistoryApi(params)
            setTableData(res.data.data)
            CtxLoad.setDisplayLoadingBlur(false)
            setCurrentPage(res.data.current_page)
            setLastPage(res.data.last_page)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingBlur(false)
        }
    }

    useEffect(() => {
        document.title = "تاریخچه خرید | دایان"
        CtxNav.setActiveMenuItem({ 'item': 6, 'subItem': 0, })
        getData(jsonParms)

    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">تاریخچه خرید</h1>

            <div className=" w-full flex flex-col">
                {tableData.map((item: any, index: number) =>
                    <div className=" w-full p-5 bg-white shadow rounded-lg mb-2 flex sm:flex-row flex-col items-center">
                        <div className="w-[calc(100%-60px)] flex-col ">
                            <span className="text-[11px] mb-1">{new Date(item.created_at).toLocaleDateString('fa-Ir')}</span>
                            <h3>{item.plan?.name}</h3>
                            <span className="mt-2  text-justify leading-6">مبلغ پرداخت شده : {CommaFire(item.plan?.amount)} تومان</span>
                        </div>
                        <div onClick={()=>exportFile(item.id)} className="w-[100px] h-[40px] border sm:mt-0 mt-3 flex items-center justify-center text-[11px] text-white rounded-lg bg-dayan-gray-200 cursor-pointer">دانلود فاکتور</div>
                    </div>
                )}
            </div>

            <div className=" w-full mt-[20px]">
                <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
            </div>


        </div>
    )
}
